<script>
  export default {
    name: 'CreateMode',
    components: {
      CommonMode: () => import('./CommonMode.vue'),
    },
    props: {
      type: {
        type: String,
        required: true,
        default: 'spreadsheet',
      },
      integration: {
        type: Object,
        required: true,
      },
    },
    data: () => ({
      name: '',
    }),
    computed: {
      title() {
        return this.type === 'spreadsheet'
          ? 'Spreadsheet name'
          : 'Database name'
      },
    },
    methods: {
      saveInfo(commonValues) {
        this.$emit('save-info', {
          name: this.name,
          ...commonValues,
        })
      },
    },
  }
</script>

<template>
  <div>
    <v-text-field
      v-model="name"
      :label="title"
      outlined
      dense
      required
    />

    <CommonMode
      :type="type"
      :integration="integration"
      @save-info="saveInfo"
    />
  </div>
</template>

<style lang="scss">
  .form-integrarion-title {
    color: var(--v-grey_3-base);
    font-size: 12px;
    font-weight: 400;
  }
</style>
